import React from 'react'

/**
 * React component
 * Renders a modal that displays all the coins that will be received for this transaction
 */

const TokensReceivedModal: React.FC = () => {
  return <div>TokensReceivedModal</div>
}

export default TokensReceivedModal
